import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { WasteStream } from "../..";

@Injectable()
export class WasteStreamService extends BaseDataService<WasteStream> {
  constructor(http: HttpService) {
    super(http, "wastestream");
  }

  createInstance(options: any): WasteStream {
    return new WasteStream(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
